
export default {
  props: {
    images: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      currentIndex: 0
    }
  },
  methods: {
    prev () {
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length
    },
    next () {
      this.currentIndex = (this.currentIndex + 1) % this.images.length
    },
    goToSlide (index) {
      this.currentIndex = index
    }
  }
}
